import classNames from 'classnames'
import { Override } from 'maeng-type/Common'
import { ComponentProps, ReactNode, forwardRef, useMemo } from 'react'

export type NavbarProps = Override<
  ComponentProps<'div'>,
  {
    left?: ReactNode
    center?: ReactNode
    right?: ReactNode
  }
>

export const Navbar = forwardRef<HTMLDivElement, NavbarProps>(
  ({ left, center, right, className: classProps = '', ...props }, ref) => {
    const className = useMemo(() => {
      return classNames({
        navbar: true,
        'justify-between': true,
        [classProps]: true,
      })
    }, [classProps])

    return (
      <div ref={ref} className={className} {...props}>
        <div className="navbar-start w-auto">{left}</div>
        <div className="navbar-center w-auto">{center}</div>
        <div className="navbar-end w-auto">{right}</div>
      </div>
    )
  },
)

export default Navbar
